"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIpValid = void 0;
// IP address validation http://www.w3resource.com/javascript/form/ip-address-validation.php
var REGEXP_IPV4_VALIDATION = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
/**
 * @description
 * checks if the IP is valid
 * @Function
 *
 * @name skybase-components.sb-ipv4-input.utils#isIpValid
 * @param {String} ip
 * @return {Boolean}
 */

var isIpValid = function isIpValid(ip) {
  return REGEXP_IPV4_VALIDATION.test(ip);
};

exports.isIpValid = isIpValid;
//# sourceMappingURL=is-ip-valid.js.map